export const PaperSx = {
  height: '675px',
};
